import LinkPreviewCard from '../components/LinkPreviewCard';
import { loadPreview, previewFor, releasePreview, retainPreview } from './previewStore';
const mounted = new Map();
export function mountCard(target) {
  const {
    link,
    url,
    internal,
    block,
    mode
  } = target;
  link.setAttribute('data-link-preview', '');
  const wrapper = document.createElement('span');
  wrapper.className = 'LinkPreview-container';
  wrapper.setAttribute('data-link-preview', '');
  if (mode === 'replace') {
    link.classList.add('LinkPreview-source');
    link.before(wrapper);
  } else {
    block.append(wrapper);
  }
  mounted.set(wrapper, {
    link,
    url
  });
  retainPreview(url);
  m.mount(wrapper, {
    view: () => m(LinkPreviewCard, {
      link,
      url,
      internal
    })
  });
  loadPreview(url, () => dropFailed(wrapper, url));
  dropFailed(wrapper, url);
}
export function sweepDetachedCards() {
  for (const wrapper of Array.from(mounted.keys())) {
    if (!wrapper.isConnected) unmount(wrapper);
  }
}
export function unmountCardsWithin(root) {
  root.querySelectorAll('.LinkPreview-container').forEach(unmount);
}
export function removeCardsWithin(root) {
  root.querySelectorAll('.LinkPreview-container').forEach(wrapper => {
    takeDown(wrapper)?.link.removeAttribute('data-link-preview');
  });
}
function dropFailed(wrapper, url) {
  if (previewFor(url).status !== 'failed') return;
  takeDown(wrapper);
}
function takeDown(wrapper) {
  const card = mounted.get(wrapper);
  unmount(wrapper);
  wrapper.remove();
  card?.link.classList.remove('LinkPreview-source');
  return card;
}
function unmount(wrapper) {
  const card = mounted.get(wrapper);
  if (!card) return;
  mounted.delete(wrapper);
  releasePreview(card.url);
  m.mount(wrapper, null);
}
flarum.reg.add('datlechin-link-preview', 'forum/utils/cardRegistry', { mountCard: mountCard,sweepDetachedCards: sweepDetachedCards,unmountCardsWithin: unmountCardsWithin,removeCardsWithin: removeCardsWithin, });